import { render, staticRenderFns } from "./KurccStaffPage.vue?vue&type=template&id=789da729&"
import script from "./KurccStaffPage.vue?vue&type=script&lang=js&"
export * from "./KurccStaffPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports